/**
* Nom : LedTypeList.js
* Description : Ce fichier contient la définition de la page LedTypeList 
*               Cette page affiche les éléments pour gérer les types de Led
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 16 mars 2026
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { GotoPage } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import { ListFilter } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* LedTypeList : affiche la page qui contient les éléments pour gérer les types de LEDs
*               un lien permet d'afficher un formulaire pour créer un nouveau type de LEDs
*               un lien permet de revenir sur la page qui liste tous les sous-ensemble
*               un lien permet d'aller sur la page qui liste tous types de PTUs
*               un lien permet d'aller sur la page qui liste tous types de carte LEDs
*
* Type : page 
*
* Parametres : 
*  None
*/
function LedTypeList() {

    // Define useState hooks
    const [waveLengths, setWaveLengths] = useState([])
    const [waveLength, setWaveLength] = useState(0)
    const [waveLengthError, setWaveLengthError] = useState(false);
    const [referenceAT, setReferenceAT] = useState('');
    const [referenceATError, setReferenceATError] = useState(false);
    const [referenceManufacturer, setReferenceManufacturer] = useState('');
    const [referenceManufacturerError, setReferenceManufacturerError] = useState(false);
    const [description, setDescription] = useState('');
    const [descriptionError, setDescriptionError] = useState(false);
    const [angle, setAngle] = useState(0);
    const [angleError, setAngleError] = useState(false);
    const [voltage, setVoltage] = useState(0);
    const [voltageError, setVoltageError] = useState(false);
    const [radiantFlux, setRadiantFlux] = useState(0);
    const [radiantFluxError, setRadiantFluxError] = useState(false);
    const [current, setCurrent] = useState(0);
    const [currentError, setCurrentError] = useState(false);
    const [manufacturer, setManufacturer] = useState('');
    const [manufacturerError, setManufacturerError] = useState(false);
    const [isDataLoading, setDataLoading] = useState(false)
    const [isCreation, setCreation] = useState(false)
    const [ledTypes, setLedTypes] = useState([])
    const [statusLedTypes, setStatusLedTypes] = useState(null)
    const [selectedWaveLength, setSelectedWaveLength] = useState(0)
    const [selectedRadiantFlux, setSelectedRadiantFlux] = useState(0);
    const [selectedCurrent, setSelectedCurrent] = useState(0);
    const [selectedManufacturer, setSelectedManufacturer] = useState(0);
    const [radiantFluxs, setRadiantFluxs] = useState([]);
    const [currents, setCurrents] = useState([]);
    const [manufacturers, setManufacturers] = useState([]);
    const [filteredLedTypes, setFilteredLedTypes] = useState(ledTypes);  
    const [validationDone, setValidationDone] = useState(false)


    // Define useContext hooks
    const { authStatus, authToken, currentUser } = useAuth();
    const { path } = useApi();


    // Define useBlocker hooks
    const shouldBlock = isCreation;
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(referenceAT, manufacturer, referenceManufacturer, description, angle, voltage, wave_length, radiant_flux, current) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("reference_AT", referenceAT);
        form_data.append("manufacturer", manufacturer);
        form_data.append("reference_manufacturer", referenceManufacturer);
        form_data.append("description", description);
        form_data.append("angle", angle);
        form_data.append("voltage", voltage);
        form_data.append("wave_length", wave_length);
        form_data.append("radiant_flux", radiant_flux);
        form_data.append("current", current);
        // Create Led Type
        const response = await fetch(path + "/api/eq-lety/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        );
        setStatusLedTypes(response["status"])
        if(response["status"] === 201){
            // Reset du formulaire
            setCreation(false)
            setReferenceAT('')
            setManufacturer('')
            setReferenceManufacturer('')
            setDescription('')
            setAngle(0)
            setVoltage(0)
            setWaveLength(0)
            setRadiantFlux(0)
            setCurrent(0)
            // Update ptuType list
            retrieveLedTypes()
        }
        setValidationDone(false)
    }

    const handleClick = (event) => {
        event.preventDefault();
        setCreation(true)
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Check of data for PTU type
        if(referenceAT === ''){
            setReferenceATError(true)
        }
        else
        {   
            setReferenceATError(false)
        }
        if(angle <= 0){
            setAngleError(true)
        }
        else
        {   
            setAngleError(false)
        }
        if(voltage <= 0){
            setVoltageError(true)
        }
        else
        {   
            setVoltageError(false)
        }
        if(waveLength <= 0){
            setWaveLengthError(true)
        }
        else
        {   
            setWaveLengthError(false)
        }
        if(radiantFlux <= 0){
            setRadiantFluxError(true)
        }
        else
        {   
            setRadiantFluxError(false)
        }
        if(current <= 0){
            setCurrentError(true)
        }
        else
        {   
            setCurrentError(false)
        }
        if(manufacturer === ''){
            setManufacturerError(true)
        }
        else
        {   
            setManufacturerError(false)
        }
        if(referenceManufacturer === ''){
            setReferenceManufacturerError(true)
        }
        else
        {   
            setReferenceManufacturerError(false)
        }
        if(description === '')
        {
            setDescriptionError(true)
        }else
        {   
            setDescriptionError(false)
        }
        setValidationDone(true)
    };

    const handleReset = (event) => {
        event.preventDefault();
        setCreation(false)
        setReferenceAT('')
        setManufacturer('')
        setReferenceManufacturer('')
        setDescription('')
        setAngle(0)
        setVoltage(0)
        setWaveLength(0)
        setRadiantFlux(0)
        setCurrent(0)
        setReferenceATError(false)
        setReferenceManufacturerError(false)
        setRadiantFluxError(false)
        setCurrentError(false)
        setManufacturerError(false)
        setAngleError(false)
        setVoltageError(false)
        setWaveLengthError(false)
    };

    async function retrieveLedTypes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve led_types
        const resLedType = await fetch(path + "/api/eq-lety/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataLedType = await resLedType.json();
        const led_type_list = dataLedType["results"]
        setLedTypes(led_type_list)
        // Listes des longueurs d'ondes
        const wave_length_list = [...new Set(led_type_list.map((led_type) => (led_type.wave_length)))]
        const wave_length_dict = wave_length_list.map((wave_length_item, index) => ({"id": index + 1, "value": wave_length_item}))
        setWaveLengths(wave_length_dict)
        // Listes des flux radiants
        const radiant_flux_list = [...new Set(led_type_list.map((led_type) => (led_type.radiant_flux)))]
        const radian_flux_dict = radiant_flux_list.map((radiantFlux_item, index) => ({"id": index + 1, "value": radiantFlux_item}))
        setRadiantFluxs(radian_flux_dict)
        // Listes des courants
        const current_list = [...new Set(led_type_list.map((led_type) => (led_type.current)))]
        const current_dict = current_list.map((current_item, index) => ({"id": index + 1, "value": current_item}))
        setCurrents(current_dict)
        // Listes des fabriquants
        const manufacturer_list = [...new Set(led_type_list.map((led_type) => (led_type.manufacturer)))]
        const manufacturer_dict = manufacturer_list.map((manufacturer_item, index) => ({"id": index + 1, "value": manufacturer_item}))
        setManufacturers(manufacturer_dict)
        // Dataloading
        setDataLoading(false)
    }

    function retrieve_param_object_from_id(list, id) {
        return (list.find((item) => (item['id'] === Number(id))))['value']
    }

    function updateFilteredLedTypes() {
        // Filter wave_length
        if( Number(selectedWaveLength) > 0 
            && Number(selectedRadiantFlux) === 0
            && Number(selectedCurrent) === 0
            && Number(selectedManufacturer) === 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength)))
        } 
        // Filter radiantFlux
        else if( Number(selectedWaveLength) === 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) === 0
                && Number(selectedManufacturer) === 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux)))
        } 
        // Filter current
        else if( Number(selectedWaveLength) === 0 
                && Number(selectedRadiantFlux) === 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) === 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.current === retrieve_param_object_from_id(currents, selectedCurrent)))
        } 
        // Filter manufacturer
        else if( Number(selectedWaveLength) === 0 
                && Number(selectedRadiantFlux) === 0
                && Number(selectedCurrent) === 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // Filter wave_length and radiantFlux
        else if( Number(selectedWaveLength) > 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) === 0
                && Number(selectedManufacturer) === 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength)
                                                                && ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux)))
        } 
        // Filter wave_length and current
        else if( Number(selectedWaveLength) > 0 
                && Number(selectedRadiantFlux) === 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) === 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength)
                                                                && ledType.current === retrieve_param_object_from_id(currents, selectedCurrent)))
        } 
        // Filter wave_length and manufacturer
        else if( Number(selectedWaveLength) > 0 
                && Number(selectedRadiantFlux) === 0
                && Number(selectedCurrent) === 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength)
                                                                && ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // Filter radiantFlux and current
        else if( Number(selectedWaveLength) === 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) === 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux) 
                                                                && ledType.current === retrieve_param_object_from_id(currents, selectedCurrent)))
        } 
        // Filter radiantFlux and manufacturer
        else if( Number(selectedWaveLength) === 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) === 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux) 
                                                                && ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // Filter current and manufacturer
        else if( Number(selectedWaveLength) === 0 
                && Number(selectedRadiantFlux) === 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.current === retrieve_param_object_from_id(currents, selectedCurrent) 
                                                                && ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // Filter wave_length and radiantFlux and current
        else if( Number(selectedWaveLength) > 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) === 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength) 
                                                                && ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux)
                                                                && ledType.current === retrieve_param_object_from_id(currents, selectedCurrent)))
        } 
        // Filter wave_length and radiantFlux and manufacturer
        else if( Number(selectedWaveLength) > 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) === 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength)
                                                                && ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux)
                                                                && ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // Filter wave_length and current and manufacturer
        else if( Number(selectedWaveLength) > 0 
                && Number(selectedRadiantFlux) === 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength)
                                                                && ledType.current === retrieve_param_object_from_id(currents, selectedCurrent)
                                                                && ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // Filter radiantFlux and current and manufacturer
        else if( Number(selectedWaveLength) === 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux)
                                                                && ledType.current === retrieve_param_object_from_id(currents, selectedCurrent)
                                                                && ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // Filter wave_length and radiantFlux and current and manufacturer
        else if( Number(selectedWaveLength) > 0 
                && Number(selectedRadiantFlux) > 0
                && Number(selectedCurrent) > 0
                && Number(selectedManufacturer) > 0)
        {
            setFilteredLedTypes(ledTypes.filter((ledType) => ledType.wave_length === retrieve_param_object_from_id(waveLengths, selectedWaveLength)
                                                                && ledType.radiant_flux === retrieve_param_object_from_id(radiantFluxs, selectedRadiantFlux)
                                                                && ledType.current === retrieve_param_object_from_id(currents, selectedCurrent)
                                                                && ledType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // No filter
        else
        {
            setFilteredLedTypes(ledTypes)
        }
    }

    const filterReset = (event) => {
        event.preventDefault();
        setFilteredLedTypes(ledTypes)
        setSelectedWaveLength(0)
        setSelectedRadiantFlux(0)
        setSelectedCurrent(0)
        setSelectedManufacturer(0)
    }


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveLedTypes()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        updateFilteredLedTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ledTypes, selectedWaveLength, selectedRadiantFlux, selectedCurrent, selectedManufacturer])

    useEffect(() => {
        if(validationDone === true && referenceATError === false && angleError === false && voltageError === false && waveLengthError === false && radiantFluxError === false && currentError === false && manufacturerError === false && referenceManufacturerError === false && descriptionError === false){
            sendData(referenceAT, manufacturer, referenceManufacturer, description, angle, voltage, waveLength, radiantFlux, current)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validationDone]);

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
        if (shouldBlock === true) {
            // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
            e.preventDefault();
            e.returnValue = "";
            // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
            return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
        }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        <div>
                            <h1>Types de LEDs</h1>
                            {/*Lien de retour*/}
                            <div className={(screenWidth > 650) ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top'}>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <BackPage path={'/equipments/subset'}>Retour aux sous-ensembles</BackPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ptuType'}>Types de PTUs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledCard'}>Cartes LEDs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledCardType'}>Types de carte LEDs</GotoPage>
                                </div>
                            </div>
                            {/*Message d'erreur*/}
                            {(statusLedTypes !== null && statusLedTypes !== 201 && referenceATError === false) ? (
                                <p className='form-error'>Le type de LED existe déjà ou n'a pas pu être enregistré !</p>
                            ) : (
                                <p/>
                            )} 
                            {/*Liste et formulaire*/}
                            <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                                <div className='flex-rows'>
                                    {/*New*/}
                                    {(currentUser["role_name"] !== "AT_RESEARCH") ? (
                                        <div className='flex-column'>
                                            <div className='link' onClick={handleClick}>
                                                <img src={AddIcon} alt='add_item_icon' className='link-img' />
                                                <div className='link-text'>Type de LED</div>
                                            </div>
                                            {(isCreation === true) ? (
                                                <div className='flex-rows'>
                                                    <h3>Nouveau type</h3>
                                                    <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                                                        <div className='flex-column'>
                                                            <InputFormSide error={referenceATError} type="text" label="Référence Asclepios Tech" value={referenceAT} setValue={setReferenceAT}/>
                                                            <p className='italic-text-note zero-margin-bottom'>Référence = numéro de la LED fabricant + "-" + valeur de la longueur d'onde</p>
                                                            <p className='italic-text-note margin-bottom'>Exemple: S3535-273</p>
                                                            <InputFormSide error={manufacturerError} type="text" label="Fabricant" value={manufacturer} setValue={setManufacturer}/>
                                                            <InputFormSide error={referenceManufacturerError} type="text" label="Référence fabricant" value={referenceManufacturer} setValue={setReferenceManufacturer}/>
                                                            <InputFormSide error={angleError} type="number" label="Angle" value={angle} setValue={setAngle}/> 
                                                            <InputFormSide error={waveLengthError} type="number" label="Longueur d'onde (en nm)" value={waveLength} setValue={setWaveLength}/> 
                                                            <InputFormSide error={voltageError} type="float" label="Tension (en V)" value={voltage} setValue={setVoltage}/>
                                                            <InputFormSide error={radiantFluxError} type="float" label="Flux radiant (en mW)" value={radiantFlux} setValue={setRadiantFlux}/>
                                                            <InputFormSide error={currentError} type="float" label="Courant (en mA)" value={current} setValue={setCurrent}/>
                                                            <InputFormSide error={descriptionError} type="text" label="Description" value={description} setValue={setDescription}/>
                                                        </div>
                                                        <div className='flex-row form-center'>
                                                            <button type="reset" className='button'>Annuler</button>
                                                            <button type="submit" className='button'>Valider</button>
                                                        </div>
                                                    </form> 
                                                </div>
                                            ) : (
                                                <div></div>
                                            )}
                                        </div>
                                    ) : (
                                        null
                                    )}
                                    {/*Filtering*/}
                                    <h3>Filtres</h3>
                                    <ListFilter labelText="Longueur d'onde" choices={waveLengths.sort((a, b) => (a.value > b.value)?1:-1)} choiceParam={'value'} selectedItem={selectedWaveLength} setSelectedItem={setSelectedWaveLength} subfilter={false}/>
                                    <ListFilter labelText='Flux radiant (en mW)' choices={radiantFluxs.sort((a, b) => (a.value > b.value)?1:-1)} choiceParam={'value'} selectedItem={selectedRadiantFlux} setSelectedItem={setSelectedRadiantFlux} subfilter={false}/>
                                    <ListFilter labelText='Courant (en mA)' choices={currents.sort((a, b) => (a.value > b.value)?1:-1)} choiceParam={'value'} selectedItem={selectedCurrent} setSelectedItem={setSelectedCurrent} subfilter={false}/>
                                    <ListFilter labelText='Fabricant' choices={manufacturers.sort((a, b) => (a.value > b.value)?1:-1)} choiceParam={'value'} selectedItem={selectedManufacturer} setSelectedItem={setSelectedManufacturer} subfilter={false}/>
                                    <div>
                                        <button onClick={filterReset} className='button-secondary clickable'>Sans filtres</button>
                                    </div>
                                </div>
                                {(screenWidth > 650) ? null : <Divider/>}
                                {/*LEDs type list*/}
                                <div className='scroll-list-rd'>
                                    {(filteredLedTypes && filteredLedTypes.length !== 0) ? (
                                        filteredLedTypes.sort((a, b) => (a.reference_AT > b.reference_AT)?1:-1).map((ledType) => (
                                            <Item key={ledType['id']} id={ledType['id']}>
                                                <h3 className='item-text'>Référence : {ledType['reference_AT']}</h3> 
                                                <div>
                                                    <div className={(screenWidth > 1100) ? 'grid-1-2' : null}>
                                                        <p className='item-text'>Fabricant : {ledType['manufacturer']}</p>
                                                        <p className='item-text'>Référence fabricant : {ledType['reference_manufacturer']}</p>
                                                    </div>
                                                    <div>
                                                        <p className='item-text'>Description : {ledType['description']}</p> 
                                                    </div>
                                                    <div className={(screenWidth > 1100) ? 'grid-1-2' : (screenWidth > 650) ? 'grid-1-1' : null}>
                                                        <p className='item-text'>Angle : {ledType['angle']}</p> 
                                                        <p className='item-text'>Longueur d'onde : {ledType['wave_length']}nm</p>
                                                    </div>
                                                    <div className={(screenWidth > 1100) ? 'grid-1-1-1' : (screenWidth > 650) ? 'grid-1-1' : null}>
                                                        <p className='item-text'>Tension : {ledType['voltage']}V</p>
                                                        <p className='item-text'>Flux radiant : {ledType['radiant_flux']}mW</p> 
                                                        <p className='item-text'>Courant : {ledType['current']}mA</p>
                                                    </div>
                                                </div>
                                            </Item>
                                        ))
                                    ) : (
                                        <p>Aucun type de LED actuellement. Veuillez en créer un !</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Container>
            </div>
        </div>
    );
}

export default LedTypeList;
